import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LinkProAccountsPayload } from '@account-users/account/models/LinkProAccountsPayload';

import { ProAccountsResponse } from '@account-users/account/models/ProAccountsResponse';

@Injectable({
  providedIn: 'root',
})
export class ProAccountsService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  getProAccounts(accountId: string) {
    return this.http.get(
      `${this.apiBaseUrl}v2/accounts/${accountId}/pro-accounts/`,
    ) as Observable<[{ id: number; name: string }]>;
  }

  putProAccounts(accountId: string, proIds: number[]) {
    return this.http.put(
      `${this.apiBaseUrl}v2/accounts/${accountId}/pro-accounts/`,
      { proIds },
    ) as Observable<ProAccountsResponse>;
  }

  deleteProAccount(accountId: string, proAccountId: number) {
    return this.http.delete(
      `${this.apiBaseUrl}accounts/${accountId}/pro-accounts/${proAccountId}`,
    );
  }

  linkProAccountIds({ accountId, proAccountIds }: LinkProAccountsPayload) {
    return this.putProAccounts(accountId, proAccountIds).pipe(
      catchError((error) => {
        console.error(error);
        this.toastr.error(
          'Could not create link between One and Pro accounts. Use the account settings page to try again',
        );
        return EMPTY;
      }),
      tap(({ failed, successful }) => {
        if (failed && failed.length) {
          failed.forEach((failure) => {
            console.error(failure);
            this.toastr.error(
              `Failed to link ${accountId} with Pro account name ${failure.account.name}.`,
              '',
              { closeButton: true, disableTimeOut: true },
            );
          });
        }

        if (successful && successful.length) {
          successful.forEach((item) => {
            this.toastr.success(
              `Successfully linked ${accountId} with Pro account name ${item.name}!`,
            );
          });
        }
      }),
    );
  }
}
